import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/Login'
import Register from '@/pages/Register'
import Unauthorized from '@/pages/error/404'
import defaultLayout from '@/layout/default'
import portalLayout from '@/layout/portal'
import store from '@/store'
import CustomReport from './routers/report'
import Dashboard from './routers/dashboard'
import Administrator from '@/pages/administrator'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // =============================================================================
    // Application Routes
    // =============================================================================
    ...Dashboard,
    ...CustomReport,
    {
      path: '/login',
      name: 'login',
      components: {
        content: Login,
        layout: defaultLayout
      },
      meta: {
        title: 'Login | Petronas',
        showLink: false,
        guest: true,
        requiresAuth: false
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: {
        beforeRouteEnter(to, from, next) {
          const destination = {
            path: '/login',
            query: from.query,
            params: from.params
          }

          store.dispatch('deleteToken')
          next(destination)
        }
      },
      meta: {
        title: 'Logout',
        showLink: false,
        requiresAuth: false
      }
    },
    {
      path: '/register',
      name: 'Register',
      components: {
        content: Register,
        layout: defaultLayout
      },
      meta: {
        title: 'Register | Petronas',
        showLink: false
        // guest: true
      }
    },
    {
      path: '/404',
      name: 'Unauthorized',
      components: {
        content: Unauthorized,
        layout: defaultLayout
      },
      meta: {
        title: 'Unauthorized access! | Petronas',
        showLink: false
      }
    },
    {
      path: '/administrator',
      name: 'administrator',
      components: {
        content: Administrator,
        layout: portalLayout
      },
      meta: {
        title: 'Administrator',
        showLink: false,
        // guest: true,
        requiresAuth: true
      }
    },
    {
      path: '/',
      redirect: '/home',
      meta: {
        showLink: false
      }
    },
    {
      path: '*',
      redirect: '/home',
      meta: {
        showLink: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'ECOCIM - Petronas'
  next()
})

// un-comment this line for activating middleware
router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // calling user profile
    await store.dispatch('getUserProfile')
    // // set current route
    // store.commit('setCurrentRoute', to)

    // console.log('inimang', store.getters)
    // return

    if (!store.getters.loggedIn) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
      return
    }
    // else if (!store.getters.authorized) {
    //   next({
    //     path: '/404',
    //     query: { nextUrl: '/' }
    //   })
    // }
    // else next()
    next()
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.loggedIn) {
      next({
        path: '/',
        params: { nextUrl: to.fullPath }
      })
    } else next()
  } else {
    next()
  }
})

export default router
